<template>
   <div class='EnProgreso'>

    <div v-if="loading">
        <div class="d-flex justify-content-center mt-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>

    <div v-else>
        <div v-if="projectos == null">
            <div class="row pt-3">
                <div class="col">
                    <div class="card">
                        <p class="text-center pt-2">Sin Proyectos</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <!-- Tabla -->
            <table class="table">
            <thead>
                <tr>
                    <th scope="col">Nombre Proyecto</th>
                    <th scope="col" >Adjudicado a:</th>
                    <th scope="col">Pais</th>
                    <th scope="col">Adjudicado </th>
                    <th scope="col">Inicio</th>
                    <th scope="col">Entrega</th>
                    <th scope="col" class="text-center">Fondeado</th>
                    <th scope="col" class="text-center">Entregado</th>
                    <th scope="col">Pagado</th>
                    <th scope="col">Concesión</th>
                    <th scope="col">Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="f in projectos" :key="f.id">
                    <td>
                        <router-link :to="{ name: 'DetalleProyecto', params: { idEmpresa: f.id_proyecto}}">
                            {{f.titulo_proyecto}}
                            <!--<span v-if="f.asignadaA != 0">
                                <small class="text-success">(Adjudicado)</small>
                            </span>-->
                        </router-link>
                    </td>
                    <!--Adjudicado a -->
                    <td>
                        <div class="row">
                            <div class="col-3">
                                <img :src="getUrl(f.avatar)" class="img">
                            </div>
                            <div class="col-9">
                                <router-link :to="{ name: 'calificacion', params: {id: f.id_user}}">
                                    @{{f.usuario}}
                                </router-link>
                                <star-rating :increment="0.1" :rating="makeNumber(f.estrellas)" :star-size="20" :show-rating="false" :read-only="true"/>
                            </div>
                        </div>
                    </td>
                    <td>
                        <img :src="getBandera(f.pais_region)" class="bandera">
                    </td>
                    <td>{{fechaFormat(f.fecha_adj)}}</td>
                    <td>{{fechaFormat(f.fecha_inicio)}}</td>
                    <td>{{fechaFormat(f.fecha_cierre)}}</td>
                    <!-- FONDEAR EMPRESA -->
                    <td>
                        <div v-if="f.fondeado == 0 && f.estatus_proyecto == 4">
                            <p class="text-center">
                                <button class="btn btn-sm btn-success" @click="metodo_pago(f)">
                                    Fondear
                                </button>
                            </p>
                        </div>
                        <div v-if="f.fondeado == 0 && f.estatus_proyecto < 3">
                            <button class="btn btn-sm btn-dark" disabled>
                                <font-icon icon="times"/>
                            </button>
                        </div>
                        <div v-if="f.fondeado == 1">
                            <p class="text-center"><font-icon icon="check" class="text-success"/></p>
                        </div>
                        <div v-if="f.fondeado == 2">
                            <p class="text-center">
                                <button class="btn btn-sm btn-danger" @click="fondeo_incompleto(f)">
                                    Fondeo Incompleto
                                </button>
                            </p>
                        </div>
                    </td>

                    <!-- TERMINADO/NO TERMINADO -->
                    <td>
                        <div v-if="f.estatus_proyecto == '8'">
                            <p class="text-center text-success"><font-icon icon="check"/></p>
                        </div>
                        <div v-else>
                            <p class="text-center text-danger"><font-icon icon="times"/></p>
                        </div>
                    </td>

                    <!--PAGAR-->
                    <td>
                        <button class="btn btn-sm btn-success"  v-if="f.estatus_nombre == 'Terminado'" @click="pagar(5,f)">
                            <font-icon icon="dollar-sign"/> Pagar
                        </button>

                        <p class="text-center text-danger" v-else>
                            <font-icon icon="times"/>
                        </p>
                    </td>

                    <td>
                        <button v-if="f.estatus_nombre != 'Terminado'" class="btn btn-sm btn-warning"
                                data-toggle="modal"
                                data-target='#modalExtender'
                                @click="fetchID(f)"
                            >
                            Extender entrega
                        </button>
                        <button v-if="f.estatus_nombre == 'Terminado'" class="btn btn-sm btn-warning" disabled>
                            Extender entrega
                        </button>

                    </td>

                    <!--PAUSAR & CANCELAR-->
                    <td>
                        <button class="btn btn-sm btn-warning" v-if="f.estatus_nombre == 'Terminado'" disabled>
                            <font-icon icon="pause"/>
                        </button>

                        <button class="btn btn-sm btn-success" v-if="f.estatus_proyecto ==6" @click="acciones(2,f)" data-toggle="tooltip" data-placement="top" title="Publicar">
                                <font-icon icon="play"/>
                        </button>

                        <button class="btn btn-sm btn-warning" @click="catchID(f)" v-if="f.estatus_proyecto != 6 && f.estatus_nombre != 'Terminado'" data-toggle="modal" data-placement="top" title="Pausar Proyecto" data-target='#modalSuspender'>
                            <font-icon icon="pause"/>
                        </button>

                        <button class="btn btn-sm btn-danger" v-if="f.fondeado == 0"
                                    data-toggle="modal"
                                    data-placement="top"
                                    title="Cancelar Proyecto"
                                    @click="catchID(f)"
                                    data-target='#modalCancelar'>
                                <font-icon icon="times"/>
                        </button>
                        <button class="btn btn-sm btn-danger" v-else @click="cancelarDos(f)" data-placement="top" title="Conciliar">
                            <font-icon icon="handshake"/>
                        </button>

                        <button class="btn orange btn-sm" @click="regChat(f.id_user,f.id_proyecto)"
                                    data-toggle="modal"
                                    data-placement="top"
                                    title="Chat">
                            <font-icon icon="comments"/>
                        </button>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>


    <!--Modal Pausar Proyecto -->
    <div class="modal fade" id="modalSuspender" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Pausar el proyecto:</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form @submit="pausar">
                <div class="modal-body">
                    <h3 class="text-center">{{nombreProyecto}}</h3>
                    <div>
                        <textarea class="form-control" v-model="razonPausa" rows="5" required maxlength="280"
                        placeholder="Indica la razón por la que pondrás en pausa la ejecución del proyecto."></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                    <button type="submit" class="btn orange"> Aceptar </button>
                </div>
            </form>
            </div>
        </div>
    </div>

    <!--Modal Cancelar -->
    <div class="modal fade" id="modalCancelar" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Cancelación del Proyecto:</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form @submit="cancelar">
                <div class="modal-body">
                    <div>
                        <h3 class="text-center">{{nombreProyecto}}</h3>
                        <textarea class="form-control" v-model="razonCancelacion" rows="5" required maxlength="100"
                        placeholder="Razon por cancelacion..."></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                    <button type="submit" class="btn orange"> Aceptar </button>
                </div>
            </form>
            </div>
        </div>
    </div>

    <!--Modal Fondeo-->
    <div class="modal fade" id="modalFondear" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" v-if="fond_inc == 0">Detalle de fondeo a realizar</h5>
                <h5 class="modal-title" v-if="fond_inc == 1">Fondeo incompleto</h5>

                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
                <div class="modal-body p-0">

                    <div class="invoice-company text-center f-w-600">
                        Proyecto {{titulo}}
                    </div>
                    <div class="invoice-user d-flex justify-content-between f-w-600">
                        <div class="text-left p-2" style="font-size: 16px;">Adjudicado a:</div>
                        <div>
                            <img :src="getUrl(avatar)" class="img">
                            <a href="#">@{{user}}</a>
                        </div>
                    </div>
                    <table class="table table-invoice mb-1">
                        <!--
                        <thead>
                            <tr>
                                <th>Descripción</th>
                                <th class="text-right" width="30%">Total</th>
                            </tr>
                        </thead>
                        -->
                        <tbody v-if="fond_inc == 0">
                            <tr>
                                <td>
                                <span class="text-inverse">Monto proyecto</span><br>
                                <!--<small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed id sagittis arcu.</small>-->
                                </td>
                                <td class="text-right">{{moneda(monto)}} <small>USD</small> </td>
                            </tr>
                            <tr>
                                <td>
                                <span class="text-inverse">Impuesto proyecto ({{TaxIVA}}%)</span><br>
                                <!--<small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed id sagittis arcu.</small>-->
                                </td>
                                <td class="text-right">{{moneda(impuesto)}} <small>USD</small></td>
                            </tr>
                            <tr>
                                <td>
                                <span class="text-inverse">Comisión uso de plataforma (9%)</span><br>
                                <!--<small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed id sagittis arcu.</small>-->
                                </td>
                                <td class="text-right">{{moneda(comision)}} <small>USD</small></td>
                            </tr>
                            <tr>
                                <td>
                                <span class="text-inverse">Impuesto uso de plataforma ({{TaxIVA}}%)</span><br>
                                <!--<small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed id sagittis arcu.</small>-->
                                </td>
                                <td class="text-right">{{moneda(impuestoP)}} <small>USD</small></td>
                            </tr>
                            <tr>
                                <td class="sub-price"> </td>
                                <td class="text-right sub-total"><span class="float-left">Sub Total</span> {{moneda(subtotal)}} USD</td>
                            </tr>
                            <tr v-if="elemsel == 'TC'">
                                <td>
                                <span class="text-inverse">Cargo por método de pago (4.45% + 0.30 USD)</span><br>
                                <!--<small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed id sagittis arcu.</small>-->
                                </td>
                                <td class="text-right">{{moneda(cargoMetodoPago)}} <small>USD</small></td>
                            </tr>
                            <tr v-if="elemsel == 'TB'">
                                <td>
                                <span class="text-inverse">Cargo por método de pago (Comisión Stripe)</span><br>
                                <!--<small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed id sagittis arcu.</small>-->
                                </td>
                                <td class="text-right">{{moneda(cargoMetodoPago)}} <small>USD</small></td>
                            </tr>
                            <tr>
                                <td class="sub-price"> </td>
                                <td class="text-right gran-total"><span class="float-left">Total a transferir</span> {{moneda(total)}} USD</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="col-sm-12 text-center mt-4 mb-3" v-if="elemsel == 'TB' && fond_inc == 1">
                      <small>
                          Tu transferencia fue incompleta, a continuación están los datos bancarios y el monto faltante.
                      </small>
                    </div>

                    <table class="table text-center table-referencia" v-if="elemsel == 'TB'">
                      <tbody>
                        <tr>
                          <td colspan="5">
                            <strong>Datos bancarios para hacer su transferencia desde su banco o banca electrónica</strong>
                          </td>
                        </tr>
                        <tr>
                          <!-- <td><strong>Beneficiario</strong> <br/> Nombre empresa (TBD) <br/> Dirección empresa </td> -->
                          <td><strong>Banco</strong> <br/> <div class="bank-data">{{banco}}</div></td>
                          <td><strong>Cuenta</strong> <br/> <div class="bank-data">{{cuenta}}</div></td>
                          <td><strong>Código SWIFT</strong> <br/> <div class="bank-data">{{ codigoBancario }}</div></td>
                          <td><strong>Referencia</strong> <br/> <div class="bank-data">{{referencia}}</div> </td>
                          <td v-if="fond_inc==1"><strong class="text-dark">Monto Faltante</strong> <br/> <h6 class="text-danger">{{montoFalta}} USD</h6></td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="col-sm-12 text-center mt-4 mb-3" v-if="elemsel == 'TB' && fond_inc == 0" style="background-color: rgb(219, 219, 219);">
                        <div class="text-danger">Aviso importante sobre cargos adicionales</div>
                        <tr></tr>
                        <div class="text-justify p-2">
                            Queremos informarle que es posible que se apliquen cargos adicionales según
                            el método de pago que haya seleccionado. Estos cargos son independientes de
                            los servicios que brindamos en itSAPp, ya que son establecidos y cobrados por
                            la institución financiera que usted elija para llevar a cabo la transferencia.
                        </div>
                    </div>
                    <!--
                    <div class="invoice-price mb-4">
                        <div class="invoice-price-left">
                            <div class="invoice-price-row">
                                <div class="sub-price text-justify">
                                    <small>
                                        Debe considerar que pueden existir cargos adicionales que dependen del método
                                        de pago que seleccione y son independientes a los servicios que ofrecemos.
                                    </small>
                                </div>
                            </div>
                            <small>
                                <a href="#" class="float-right pl-4">Ver politicas de cargos y tarifas</a>
                            </small>
                        </div>
                        <div class="invoice-price-right">
                            <small>TOTAL</small> <span class="f-w-600">{{moneda(total)}} USD</span>
                        </div>
                    </div>
                    -->
                </div>
                <div class="modal-footer">
                    <small>
                        <a :href="urlWeb+ '/assets/pdf/politicaCargosTarifas.pdf'" class="float-right">Ver politicas de cargos y tarifas</a>
                    </small>
                    <button type="button" @click="aceptarFondeo" class="btn orange" v-if="elemsel =='TC'">Proceder con el fondeo</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal seleccionar tipo de pago -->
    <div class="modal fade" tabindex="-1" role="dialog" id="modalMetodoPago" aria-hidden='true' data-backdrop='static'>
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        Metodo de pago
                    </h5>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <select class="form-control" name="elemsel" v-model="elemsel">
                            <option value="TB">Transferencia bancaria</option>
                            <option value="TC">Tarjeta credito/debito</option>
                        </select>
                    </div>
                    <div v-if="elemsel =='TC'" class="col-sm-12 pt-3" style="border-top: solid 1px whitesmoke;">
                        Ingrese los datos de la tarjeta
                        <stripe-element-card
                            ref="elementRef"
                            :hidePostalCode="true"
                            :pk="this.publishKey"
                            @token="CreateToken"
                        />
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-warning" @click="submit">
                        Resumen de pago
                    </button>
                    <button type="button"
                            class="btn btn-light"
                            data-dismiss="modal">
                        Cerrar
                    </button>
                </div>

            </div>
        </div>
    </div>

    <!-- Modal seleccionar tipo de pago -->
    <!--
    <div class="modal fade" tabindex="-1" role="dialog" id="modalDetallePago" aria-hidden='true' data-backdrop='static'>
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        Detalle de pago
                    </h5>
                </div>
                <div class="modal-body p-0">
                    <table class="table">
                        <tbody>
                            <tr>
                                <td>Referencia </td>
                                <td class="text-right">
                                    {{referencia}}
                                </td>
                            </tr>
                            <tr>
                                <td>Cuenta CLABE</td>
                                <td class="text-right">
                                    284 525 5485
                                </td>
                            </tr>
                            <tr>
                                <td>Cuenta BBVA</td>
                                <td class="text-right">
                                    115 456 7080
                                </td>
                            </tr>
                            <tr>
                                <td>Código SWIFT</td>
                                <td class="text-right">
                                    BCMRMX5254
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Total
                                </td>
                                <td class="text-right">
                                    $ {{moneda(total)}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button"
                            class="btn btn-light"
                            data-dismiss="modal">
                        Ok
                    </button>
                </div>

            </div>
        </div>
    </div>
    -->

    <!--Modal Extender Entrega -->
    <div class="modal fade" id="modalExtender" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Extender fecha de entrega del proyecto:</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form @submit="cambiarFecha">
                <div class="modal-body">
                    <h3 class="text-center">{{nombreProyecto}}</h3>
                    <hr>
                    <label for="">Fecha Actual</label>
                    <input type="date" class="form-control" v-model="fechaAnterior" disabled>
                    <br>
                    <label for="">Nueva Fecha</label>
                    <input type="date" class="form-control" v-model="newFecha" required>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                    <button type="submit" class="btn orange"> Cambiar </button>
                </div>
            </form>
            </div>
        </div>
    </div>

    <!--Modal Help Desk-->
    <div class="modal fade" id="helpdeskModal" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">Solicitud de conciliacion para el proyecto:</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h3 class="text-center">{{nombreProyecto}}</h3>
                    <p>
                        Envíenos un correo para apoyarle en la gestión de Conciliacion del proyecto al siguiente correo:
                        <a href="ejemplo@gmail.com">
                            reconcilement@itsapp.com.mx
                        </a>
                    </p>
                    <p>Indicándonos: Nombre de Usuario, el correo electrónico con el que se registró en nuestra página y el nombre del proyecto,
                    dándonos una breve descripción de su solicitud.</p>
                </div>
            </div>
        </div>
    </div>

   </div>
</template>


<script>
import $ from 'jquery'
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import StarRating from 'vue-star-rating'
import { StripeElementCard } from '@vue-stripe/vue-stripe';

export default {
name: 'EnProgreso',
components:{ StarRating, StripeElementCard },
mixins: [ globalFunctions ],
data () {
    return {
        projectos: [],
        loading: true,
        razonCancelacion: '',
        razonPausa: '',
        id: '',
        referencia: 0,
        monto: 0,
        titulo: '',
        user: '',
        impuesto: 0,
        comision: 0,
        impuestoP: 0,
        cargoMetodoPago: 2,
        total: 0,
        id_proyecto: 0,
        elemsel: "TB",
        avatar: '',
        activeID : '',
        fechaAnterior : '',
        nombreProyecto: '',
        newFecha: '',
        TaxIVA: '',
        banco:'',
        cuenta:'',
        codigoBancario:'',
        montoFalta:0,
        fond_inc: 0,
    }
},
methods: {
aceptarFondeo(){

    let data = {
          token: this.tokenId,
          amount: (this.total) * 100,
          userId: localStorage.userID
        };
    let url = this.urlApi + '/fondear/' + this.id_proyecto;

    this.axios
        .post(url, data)
        .then(response => {
            this.enviarCorreo(8, 'Proyecto fondeado', this.id_proyecto);
            $('#modalFondear').modal('hide');
            this.getData();
        })
        .catch(e => {
        }
    );
},
submit() {

    this.calcular_totales();

    if (this.elemsel == "TC") {
        //this.PaymentIntent();
        this.$refs.elementRef.submit();
    }

    if (this.elemsel == "TB") {
        let data = {
          amount: (this.total) * 100,
          userId: localStorage.userID
        };
        
        let url = this.urlApi + '/fondear/transferencia/' + this.id_proyecto;
        this.axios
            .post(url, data)
            .then(response => {
                this.referencia = response.data.reference;
                this.banco = response.data.financial_addresses[1].swift.bank_name;
                this.cuenta = response.data.financial_addresses[1].swift.account_number;
                this.codigoBancario = response.data.financial_addresses[1].swift.swift_code;
                this.montoFalta = response.data.amount_remaining / 100;
            })
            .catch(e => {
            }
        );
    }
    $('#modalMetodoPago').modal('hide');
    $('#modalFondear').modal('show');

},
CreateToken (token) {
    this.tokenId = token.id;
    this.card = token.card.id
},
getData(){
    let data = {
        id: localStorage.userID,
        prop: 3,
        flag:0
    };

    this.axios.post(this.url + 'getProyectos.php',data).then((responce) =>{
        this.projectos = responce.data;
        this.loading = false;
        this.$emit("update");
    });
},
catchID(f){
    this.activeID = f.id_proyecto;
    this.fechaAnterior = f.fecha_cierre;
    this.nombreProyecto = f.titulo_proyecto;
},

cambiarFecha(e){
        e.preventDefault();

        if(this.newFecha <= this.fechaAnterior){
            this.msjError("Nueva Fecha debe ser mayor a fecha anterior");
            return;
        }
         let data = {
            flag:9,
            id:this.activeID,
            nuevaFecha: this.newFecha
        };

        this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
            if(responce.data == 200){
                this.msjOk("Fecha Actualizada");
                this.nuevaFecha = '';
                $('#modalExtender').modal('hide');
                this.getData();
                this.$emit("update");
            }
        });
    },

fetchID(f){
    this.activeID = f.id_proyecto;
    this.fechaAnterior = f.fecha_cierre;
    this.nombreProyecto = f.titulo_proyecto;
},


cancelar(e){
        e.preventDefault();

        this.$swal.fire({
            title: '¿Estas Seguro?',
            text: "Ya no podras revertir el cambio",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, cancelar proyecto'
            }).then((result) => {
                if (result.isConfirmed) {

                    let data = {
                        flag:0,
                        num: 7, //status
                        id: this.activeID,
                        razon: this.razonCancelacion
                    };

                    this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
                        if(responce.data == 200){
                            this.getData();
                            this.$swal.fire(
                             'Cancelado',
                             'Tu proyecto ha sido cancelado.',
                             'success'
                            );
                            this.razonCancelacion = "";
                            $('#modalCancelar').modal('hide');
                        }
                    });
                }
            })
},

cancelarDos(f){
    $('#helpdeskModal').modal('show');
    this.catchID(f);
},

pausar(e){
    e.preventDefault();
    let data = {
        flag: 6,
        num: 6, //status
        id: this.activeID,
        razon: this.razonPausa,
        quien: 1
    };

    this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
        if(responce.data == 200){
            //this.enviarCorreo(18, 'Pausa proyecto en ejecución', this.activeID);
            this.msjOk("Proyecto Pausado");
            this.getData();
            this.inputRazon = '';
            $('#modalSuspender').modal('hide');
        }else{
            alert("Error");
        }
    });
},

pagar(num,f){
    let data = {
        flag:0,
        num:num, //status
        id:f.id_proyecto,
        id_user: f.id_user
    };

    this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
        if(responce.data == 200){
            this.enviarCorreo(9, 'Pago proyecto concluido', f.id_proyecto);
            this.msjOk("Proyecto Pagado");
            this.getData();
        }
    });
},

regChat(consultor, proyecto){
    let data = {
        flag: 0,
        idProyecto: proyecto,
        idEmpresa: localStorage.userID,
        idConsultor: consultor
    }

    this.axios.post(this.url + 'altaChat.php', data).then((responce) =>{
        if(responce.data == 200){
            this.$router.push('/Blog?tabla=' + consultor + '&tabla2=' + proyecto);
        }
    })
},


fondear(){

    /*let data = {
        flag:1,
        id: this.id_proyecto
    };

    this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
        if(responce.data == 200){
            //this.msjOk("Fondeado");
            alert("Se hace el fondeo automatico, pero la idea es que lo haga un admin al revisar que se haya hecho el deposito");
            this.getData();
        }else {
            this.msjError("El proyecto esta pausado, causa: \n" + responce.data);
            this.$swal.fire({
                icon: 'info',
                title: 'Pausado por el cliente',
                text: 'Razon: ' + responce.data,
            })
        }
    });*/
},
metodo_pago(f) {
    this.selected = f;
    this.fond_inc = 0;
    $('#modalMetodoPago').modal('show');
},
fondeo_incompleto(f) {
    this.selected = f;
    this.elemsel = "TB";
    this.fond_inc = 1;
    this.submit();
},
showResumen(f){
  this.selected = f;
  $('#modalFondear').modal('show');
},
/*
PaymentIntent(){

  let data = {amount: this.total};
  let url = this.urlApi + '/paymentintent';

  this.axios
      .post(url, data)
      .then(response => {
          this.paymentintent = response.data;
      })
      .catch(e => {
      }
  );

},
*/
calcular_totales () {

    this.titulo = this.selected.titulo_proyecto;
    this.user = this.selected.usuario;
    this.avatar = this.selected.avatar;
    this.id_proyecto = this.selected.id_proyecto;
    //this.referencia = this.selected.referencia;

    // Cambiar por variables locales
    this.cargoMetodoPago = 0;
    this.monto = Number(this.selected.monto_proyecto);
    this.TaxIVA = this.selected.TaxIVA * 100;
    this.impuesto = Number(this.monto * this.selected.TaxIVA);
    //this.impuesto = Number(this.impuesto);
    this.comision = Number( (this.monto / 100) * 9 );
    //this.comision = Number(this.comision);
    this.impuestoP = Number(this.comision * this.selected.TaxIVA);

    this.subtotal = this.monto + this.impuesto + this.impuestoP + this.comision;

    if (this.elemsel == 'TC') {
      this.cargoMetodoPago = (this.subtotal * .0445) + 0.30;
    }

    if (this.elemsel == 'TB') {
        this.cargoMetodoPago = Math.round((this.subtotal * .005) * 100) / 100; 
        if(this.cargoMetodoPago > 5)
            this.cargoMetodoPago = 5;
    }
    
    // SE MULTIPLICA POR 100 PARA TENER LOS CENTAVOS DE DOLAR
    this.total = this.monto + this.impuesto + this.impuestoP + this.comision + this.cargoMetodoPago;
    // hasta aqui

}
},
computed:{
    ...mapState(['url', 'urlApi', 'publishKey','urlWeb'])
},
mounted(){
    this.getData();
}
}
</script>


<style scoped>

    .table-referencia {
      font-size: 12px;
      background: #f0f3f4;
    }
    .sub-total {
        background: #6c757d;
        color: #fff;
        padding-top: 15px;
        padding-bottom: 15px;
    }
    .gran-total {
        background: #2b2a29;
        color: #fff;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .invoice-company {
        font-size: 20px;
        padding: 10px;
    }
    .invoice-user {
        font-size: 15px;
        padding: 5px;
        background: #f0f3f4;
    }
    .invoice-price {
        background: #f0f3f4;
        display: table;
        width: 100%;
        margin-bottom: 10px;
    }

    .invoice-price .invoice-price-left,
    .invoice-price .invoice-price-right {
        display: table-cell;
        padding: 10px;
        font-size: 20px;
        font-weight: 600;
        width: 75%;
        position: relative;
        vertical-align: middle;
    }

    .invoice-price .invoice-price-left .sub-price {
        display: table-cell;
        vertical-align: middle;
        padding: 0 20px
    }

    .invoice-price small {
        font-size: 12px;
        font-weight: 400;
        display: block
    }

    .invoice-price .invoice-price-row {
        display: table;
        float: left;
    }

    .invoice-price .invoice-price-right {
        width: 25%;
        background: #2b2a29;
        color: #fff;
        font-size: 23px;
        text-align: right;
        vertical-align: bottom;
        font-weight: 300;
    }

    .invoice-price .invoice-price-right small {
        display: block;
        opacity: .6;
        position: absolute;
        top: 10px;
        left: 10px;
        font-size: 12px;
    }
    .bank-data{
        font-size: 14px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/views/Proyectos/components/Empresa/EnProgreso.vue